import { useEffect } from 'react'
import { useBlocker } from 'react-router'
import { useLocation, useParams } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { SpinnerLoader } from 'shared/ui'
import {
  ChatbotDialog,
  ChatbotLayout,
  ChatbotLayoutContent,
  ChatbotLayoutWrapper,
  DialogLayout,
  RootLayout,
} from 'pages/chatbot/ui'
import {
  ChatbotDialogProvider,
  ChatbotProvider,
  useChatbotContext,
  useChatbotDialogContext,
} from 'pages/chatbot/context'
import { ChatbotBody } from 'pages/chatbot/ui/ChatbotEdit'
import { ChatbotEditHead } from './ChatbotEditHead'

const ChatbotEdit = observer(() => {
  const { start } = useChatbotDialogContext()
  const {
    loaded,
    enrollment,
    isDraggingCondition,
    initResources,
    loadChatbot,
    confirmUpdateChatbot,
    checkChanges,
    model: { firstMessage },
  } = useChatbotContext()

  const { state } = useLocation()
  const { agentId } = useParams()
  const blocker = useBlocker(() => {
    const hasChanges = checkChanges()

    return hasChanges
  })

  useEffect(() => {
    if (blocker.state === 'blocked') confirmUpdateChatbot(blocker)
  }, [blocker.state])

  useEffect(() => {
    initResources()
    enrollment.initFilters()

    if (!agentId) return

    loadChatbot(+agentId).then((loaded) => {
      if (loaded && state?.test) start(firstMessage.isAutoConvType)
    })
  }, [])

  return (
    <>
      {!loaded ? (
        <SpinnerLoader ariaLabel={'ChatbotEdit'} />
      ) : (
        <ChatbotLayout>
          <ChatbotLayoutWrapper>
            <ChatbotLayoutContent isDraggingCondition={isDraggingCondition}>
              <ChatbotBody />
            </ChatbotLayoutContent>
          </ChatbotLayoutWrapper>
        </ChatbotLayout>
      )}
    </>
  )
})

const ChatbotEditDialog = observer(() => {
  const { loaded } = useChatbotContext()
  const { started } = useChatbotDialogContext()

  if (!loaded) return null

  return (
    <DialogLayout active={started}>
      <ChatbotDialog />
    </DialogLayout>
  )
})

export const ChatbotEditPage = () => (
  <ChatbotProvider>
    <ChatbotDialogProvider>
      <ChatbotEditHead />
      <RootLayout>
        <ChatbotEdit />
        <ChatbotEditDialog />
      </RootLayout>
    </ChatbotDialogProvider>
  </ChatbotProvider>
)
